// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"3d93fb92","96":"8aaddf7b","973":"0dd9a814"}[chunkId] + ".chunk.js";
};